import {GetGroupedPlannedHours, TimeReportItem} from '../../../features/time-report/types';

export const getTimeReportEmployeePlannedHours = (
    items: TimeReportItem[],
    employeeTotalsById: Map<number, number>,
    useEmployeeTotals: boolean
): number => {
    if (useEmployeeTotals) {
        const employeeId = items[0]?.id;
        if (employeeId !== undefined) {
            return employeeTotalsById.get(employeeId) ?? GetGroupedPlannedHours(items);
        }
    }

    return GetGroupedPlannedHours(items);
};
